import request from '@/api/axios';

// 验证是否注册
const IsExistPhone = (params: object) => {
  params.isApi2 = true
  return request({
    // url: '/crm/api/is/exist',
    url: '/user/center/api/is/exist', // 更换二期接口
    method: 'get',
    data: params
  });
};
// 手机号码获取验证码
const RegisterCodePhone = (params: object) => {
  params.sendOrigin = 0
  params.isApi2 = true
  return request({
    // url: '/system/api/sms/login',
    url: '/user/center/api/sms/login', // 更换二期接口
    method: 'get',
    data: params
  });
};

// 手机号码注册
const RegisterPhone = (params: object) => {
  var trackParams = JSON.parse(localStorage.getItem('trackParams')) || {};
  if(trackParams.activitySn){
    params.sourceActivitySn = trackParams.activitySn
  }else{
    params.sourceActivitySn = ''
  }
  params.isApi2 = true
  return request({
    // url: '/crm/api/register',
    url: '/user/center/api/register', // 更换为二期接口
    method: 'post',
    data: params
  });
};

// 验证身份
const verifyNumber = (params: object) => {
  params.isApi2 = true
  return request({
    // url: '/crm/api/verify',
    url: '/user/center/api/verify', // 更换为二期接口
    method: 'put',
    data: params
  });
};



// 找回密码
const callbackPassword = (params: object) => {
  params.isApi2 = true
  return request({
    // url: '/crm/api/password',
    url: '/user/center/api/password', // 更换为二期接口
    method: 'put',
    data: params
  });
};

// 登陆验证码获取token
const LoginCodeUser = (params: object) => {
  let paramsApi = ltransformRequest(params)
  return request({
    // url: '/auth/oauth/token',
    url: '/user/center/oauth/token', //  // 更换二期接口
    method: 'post',
    data: paramsApi
  });
};


// 密码
const LoginUser = (params: object) => {
  // let paramsApi = ltransformRequest(params)
  // return request({
  //   url: '/auth/login',
  //   method: 'post',
  //   data: paramsApi,
  // });
}
function ltransformRequest(params) {
  let ret = "";
  for (let it in params) {
    ret += encodeURIComponent(it) + "=" + encodeURIComponent(params[it]) + "&";
  }
  return ret;
}

// rsa加密
const rsaInner = () => {
  // return request({
  //   url: '/test/auth/rsa',
  //   method: 'get',
  // });
}


// 退出登录
const outLogin = (params: object) => {
  params.isApi2 = true
  return request({
    // url: '/auth/logout',
    url: '/user/center/logout', // 更换二期接口
    method: 'get',
    data: params,
  });
}

const wxLogin = (params: object) => {
  params.isApi2 = true
  return request({
    // url:"/crm/api/wxLogin",
    url: '/user/center/api/wxLogin',  // 更换二期接口
    method: 'get',
    data: params,
  })
}

const isDisable = (params: object) => {
  params.isApi2 = true
  return request({
    url: '/user/center/api/client/is/disable',  // 更换二期接口
    method: 'get',
    data: params,
  })
}

const loginApi = {
  IsExistPhone,
  RegisterCodePhone,
  RegisterPhone,
  verifyNumber,
  callbackPassword,
  LoginCodeUser,
  LoginUser,
  rsaInner,
  outLogin,
  wxLogin,
  isDisable,
}

export default loginApi